import { defineStore } from 'pinia';

const workflowStore = defineStore('workflowStore', {
    state: () => ({
        workflows: {
            // workflow settings go in here
        },
        orderedStepState: {
            // Step order goes here
        }
    }),
    getters: {
        getStepState: (state) => (assignmentId, workflowId, affId) => {
            let wfKey = assignmentId + '_' + workflowId;
            let visibleIndex = null;
            let prevStepIndex = null;
            let nextStepIndex = null;
            let previousStepsComplete = null;
            let previousStepsLoaded = null;
            // Return empty object if we don't have a step in the store yet
            if (!state.workflows[wfKey]?.[affId]) {
                return {
                    prevStep: {},
                    nextStep: {},
                    step: {},
                    visibleIndex,
                    prevStepIndex,
                    nextStepIndex,
                    previousStepsComplete,
                    previousStepsLoaded
                };
            }
            let step = state.workflows[wfKey][affId];
            let stepIndex = state.orderedStepState[wfKey].keys.indexOf(affId);
            // fill empty indexes before analyzing
            // TODO we might need includeArray if we change "set current status when previous step is complete"
            // let includeArray = [...state.orderedStepState[wfKey].include];
            let visArray = [...state.orderedStepState[wfKey].visible];
            let completeArray = [...state.orderedStepState[wfKey].complete];
            let loadedArray = [...state.orderedStepState[wfKey].loaded];
            // Set previousStepsComplete
            previousStepsLoaded = stepIndex === 0 || loadedArray.slice(0, stepIndex).every((isLoaded) => isLoaded);
            visibleIndex = !previousStepsLoaded || !step.include
                ? -1
                : visArray.slice(0, stepIndex).reduce((acc, isVisible) => acc + (isVisible ? 1 : 0), 0);
            // Set Previous (ignore first step)
            if (stepIndex > 0) {
                prevStepIndex = visArray.slice(0, stepIndex).findLastIndex((isVisible) => isVisible);
            }
            // Set Next (ignore last step)
            if (stepIndex + 1 <= visArray.length - 1) {
                nextStepIndex = visArray.slice(stepIndex + 1, visArray.length - 1).findIndex((isVisible) => isVisible);
                if (nextStepIndex === -1) nextStepIndex = 0;
                nextStepIndex += stepIndex + 1;
            }
            previousStepsComplete = stepIndex === 0 // Is not first and all steps complete or not visible
                || (
                    previousStepsLoaded
                    && completeArray.slice(0, stepIndex)
                        .every((isComplete, iIndex) => (isComplete || visArray[iIndex] === false))
                );
            let prevAffId = typeof prevStepIndex === 'number' && prevStepIndex > -1 && state.orderedStepState[wfKey].keys[prevStepIndex];
            let nextAffId = typeof nextStepIndex === 'number' && nextStepIndex > -1 && state.orderedStepState[wfKey].keys[nextStepIndex];
            return {
                affId,
                step,
                prevAffId,
                nextAffId,
                prevStep: state.workflows[wfKey][prevAffId],
                nextStep: state.workflows[wfKey][nextAffId],
                rawIndex: state.workflows[wfKey][affId].index,
                visibleIndex,
                stepIndex,
                include: step.include,
                visible: step.visible,
                enable: step.enable,
                expiring: step.expiring,
                expired: step.expired,
                complete: step.complete,
                loaded: step.loaded,
                previousStepsLoaded,
                previousStepsComplete
            };
        },
    },
    actions: {
        updateWorkflowStep(assignmentId, workflowId, currentStepState, stepIndex) {
            let wfKey = assignmentId + '_' + workflowId;
            if (!this.orderedStepState[wfKey]) {
                this.orderedStepState[wfKey] = {
                    keys: [],
                    include: [],
                    loaded: [],
                    visible: [],
                    enable: [],
                    expiring: [],
                    expired: [],
                    complete: []
                };
            }
            if (!this.workflows[wfKey]) this.workflows[wfKey] = {};
            let affId = currentStepState.AFFILIATION_ID;
            this.orderedStepState[wfKey].keys[stepIndex] = affId;
            this.orderedStepState[wfKey].include[stepIndex] = currentStepState.include;
            this.orderedStepState[wfKey].visible[stepIndex] = currentStepState.visible;
            this.orderedStepState[wfKey].enable[stepIndex] = currentStepState.enable;
            this.orderedStepState[wfKey].expiring[stepIndex] = currentStepState.expiring;
            this.orderedStepState[wfKey].expired[stepIndex] = currentStepState.expired;
            this.orderedStepState[wfKey].complete[stepIndex] = currentStepState.complete;
            this.orderedStepState[wfKey].loaded[stepIndex] = currentStepState.loaded;
            this.workflows[wfKey][affId] = currentStepState;
        }
    }
});

export { workflowStore };
